import { OBJECT_MANAGER_ITEM_ID } from './hooks/useCustomObjectDefinition';
import ReplatformMap from './ReplatformMap';
import { PageType } from './types';

const getBasePathForObject = (objectType: string) =>
  `/platform/apps/com_zuora/${objectType}`;

const getBasePathForISH = (objectType: 'refund' | 'payment') => {
  return `/platform/apps/com_zuora/${objectType}?~(ish~true)`;
};

export default {
  'Zuora/Customers/CustomerAccounts': getBasePathForObject('account'),
  'Zuora/Billing/Invoices': ReplatformMap['/apps/NewInvoice.do'][PageType.list],
  'Zuora/Billing/BillRuns':
    ReplatformMap['/apps/NewBillingRun.do'][PageType.list],
  'Zuora/Billing/Usage': ReplatformMap['/apps/Usages.do'][PageType.list],
  'Zuora/Customers/Subscriptions': getBasePathForObject('subscription'),
  'Zuora/Customers/Amendments': getBasePathForObject('amendment'),
  'Zuora/Products/ProductCatalog':
    ReplatformMap['/apps/Product.do'][PageType.list],
  'Zuora/Products/Features': ReplatformMap['/apps/Feature.do'][PageType.list],
  'Zuora/Products/CatalogRules': '/platform/apps/catalog/rules',
  'Zuora/Products/Packaging/ConfigurableBundles':
    '/platform/apps/catalog/configurable-bundle/new',
  'Zuora/Products/Packaging/FixedBundles': '/platform/apps/catalog/bundle',
  'Zuora/Products/Packaging/Features': '/platform/apps/catalog/features',
  'Zuora/Products/Packaging/Entitlements':
    '/platform/apps/feature-entitlements-dashboard',
  'Zuora/Products/OfferManagement/ProductRecommendations':
    '/platform/apps/catalog/rules?group=recommendation',
  'Zuora/Products/OfferManagement/SubscriberLifecycle':
    '/platform/apps/catalog/rules?group=subscriber_lifecycle',
  'Zuora/Payments/PaymentsPayments':
    ReplatformMap['/apps/NewPayment.do'][PageType.list],
  'Zuora/Payments/PaymentRuns':
    ReplatformMap['/apps/PaymentRun.do'][PageType.list],
  'Zuora/Payments/PaymentMethods':
    ReplatformMap['/apps/NewPaymentMethod.do'][PageType.list],
  'Zuora/Payments/Refunds': ReplatformMap['/apps/ARRefund.do'][PageType.list],
  'Zuora/Billing/InvoiceAdjustments': getBasePathForObject('invoiceadjustment'),
  'Zuora/Billing/InvoiceItemAdjustments': getBasePathForObject(
    'invoiceitemadjustment',
  ),
  'Zuora/Finance/AccountingRun':
    ReplatformMap['/apps/JournalRuns.dox'][PageType.list],
  'Zuora/Finance/AccountingPeriods':
    ReplatformMap['/apps/AccountingPeriods.dox'][PageType.list],
  'Zuora/Customers/Orders': ReplatformMap['/orders'][PageType.list],
  'Zuora/Billing/CreditDebitMemos':
    ReplatformMap['/apps/ARSettlement.do'][PageType.list],
  'Zuora/Payments/UpdaterBatch':
    ReplatformMap['/apps/UpdaterBatch.do'][PageType.list],
  'Zuora/Payments/GatewayReconciliation':
    ReplatformMap['/apps/Reconciliation.do'][PageType.list],
  'Zuora/Payments/Connections': '/platform/apps/payments/connections',
  'Zuora/Payments/Routing': '/platform/apps/payments/routing',
  'Zuora/Payments/Checkout': '/platform/apps/payments/checkout',
  'Zuora/Payments/Transactions': '/platform/apps/com_zuora/transactions',
  'Zuora/Payments/PaymentLinks': '/platform/apps/dynamic-hpf/paymentLinks',
  'Zuora/Payments/Retry': '/platform/apps/payments/retry',
  'Zuora/AdvancedPayments/AdvancedPaymentsPayments':
    getBasePathForISH('payment'),
  'Zuora/AdvancedPayments/AdvancedPaymentsRefunds': getBasePathForISH('refund'),
  [OBJECT_MANAGER_ITEM_ID]: '/platform/apps/default/definitions',
};
